import {
  build_info_banner_block,
  build_point_list_block,
  build_value_proposition_block,
} from "./utilities";

export const vivamod_sections = () => [
  build_info_banner_block({
    image: "/assets/images/liveeps/statics/vm-fascia-welfare-1.jpg",
    title: "Servizi di viaggio per programmi loyalty",
    description:
      "Come rendere davvero felici i tuoi clienti migliori? Permettendo loro di spendere i punti o i crediti accumulati in viaggi! Il tuo brand non sarà più solo un servizio ma un vero e proprio abilitatore di sogni!",
  }),
  build_info_banner_block({
    image: "/assets/images/liveeps/statics/vm-fascia-welfare-2.jpg",
    title: "Convenzioni per viaggiare con sconti veri!",
    description:
      "Sei un'azienda, un’associazione di categoria, un CRAL, una community e offri convenzioni ai tuoi associati? La piattaforma Vivamod può diventare parte del tuo ecosistema di convenzioni, offrendo sconti trasparenti e disponibilità in tempo reale.",
  }),
  build_value_proposition_block([
    {
      vp_image: "assets/images/liveeps/statics/iStock-1208856002.jpg",
      vp_content: [
        {
          vp_icon: "symbol_lb",
          vp_title: "Ad assistere i tuoi clienti pensiamo noi",
          vp_text:
            "Assistere i clienti nella programmazione di un viaggio o negli imprevisti in loco non è semplice. Ti forniamo un customer care esperto in grado di assistere i tuoi clienti in modo veloce e professionale.",
        },
        {
          vp_icon: "symbol_lb",
          vp_title: "Un sistema integrabile e personalizzato",
          vp_text:
            "Il nostro team di ingegneri, informatici ed esperti di intelligenza artificiale è al tuo servizio per personalizzare la piattaforma e per integrarla con i tuoi sistemi in modo sicuro.",
        },
      ],
    },
  ]),
  build_point_list_block([
    {
      pl_icon: "shield",
      pl_title: "Un mondo di viaggi",
      pl_text: "25 anni di esperienza nel settore travel tech",
    },
    {
      pl_icon: "happy_pin",
      pl_title: "Per le aziende",
      pl_text: "400.000 viaggiatori scelgono ogni anno le nostre piattaforme",
    },
    {
      pl_icon: "hands",
      pl_title: "La nostra assistenza",
      pl_text: "Centinaia di aziende sono integrate con i nostri sistemi",
    },
  ]),
];
